import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=0e9b6082&scoped=true&"
var script = {}
import style0 from "./HomeSection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HomeSection.vue?vue&type=style&index=1&id=0e9b6082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9b6082",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VParallax,VRow})
